export default "__VITE_ASSET__CpFso1hZ__"